export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User is not found"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
}